import { render, staticRenderFns } from "./SettingsBotAddChannelEditor.vue?vue&type=template&id=34ad4de0&"
import script from "./SettingsBotAddChannelEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsBotAddChannelEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports